import { _ as _defineProperty } from './chunk-1fafdf15.js';
import './helpers.js';
import { c as config } from './chunk-bd4264c6.js';
import './chunk-0928016a.js';
import { _ as __vue_normalize__, r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-e3b0b539.js';
import './chunk-db919f11.js';
import { T as TabbedMixin, a as TabbedChildMixin } from './chunk-dad7a70a.js';
var script = {
  name: 'BTabs',
  mixins: [TabbedMixin('tab')],
  props: {
    expanded: {
      type: Boolean,
      "default": function _default() {
        return config.defaultTabsExpanded;
      }
    },
    type: {
      type: [String, Object],
      "default": function _default() {
        return config.defaultTabsType;
      }
    },
    animated: {
      type: Boolean,
      "default": function _default() {
        return config.defaultTabsAnimated;
      }
    },
    multiline: Boolean
  },
  computed: {
    mainClasses: function mainClasses() {
      return _defineProperty({
        'is-fullwidth': this.expanded,
        'is-vertical': this.vertical,
        'is-multiline': this.multiline
      }, this.position, this.position && this.vertical);
    },
    navClasses: function navClasses() {
      var _ref2;

      return [this.type, this.size, (_ref2 = {}, _defineProperty(_ref2, this.position, this.position && !this.vertical), _defineProperty(_ref2, 'is-fullwidth', this.expanded), _defineProperty(_ref2, 'is-toggle-rounded is-toggle', this.type === 'is-toggle-rounded'), _ref2)];
    }
  }
};
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "b-tabs",
    "class": _vm.mainClasses
  }, [_c('nav', {
    staticClass: "tabs",
    "class": _vm.navClasses
  }, [_c('ul', _vm._l(_vm.items, function (childItem) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: childItem.visible,
        expression: "childItem.visible"
      }],
      key: childItem.value,
      "class": [childItem.headerClass, {
        'is-active': childItem.isActive,
        'is-disabled': childItem.disabled
      }]
    }, [childItem.$slots.header ? _c('b-slot-component', {
      attrs: {
        "component": childItem,
        "name": "header",
        "tag": "a"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.childClick(childItem);
        }
      }
    }) : _c('a', {
      on: {
        "click": function click($event) {
          return _vm.childClick(childItem);
        }
      }
    }, [childItem.icon ? _c('b-icon', {
      attrs: {
        "icon": childItem.icon,
        "pack": childItem.iconPack,
        "size": _vm.size
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(childItem.label))])], 1)], 1);
  }), 0)]), _c('section', {
    staticClass: "tab-content",
    "class": {
      'is-transitioning': _vm.isTransitioning
    }
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Tabs = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

var script$1 = {
  name: 'BTabItem',
  mixins: [TabbedChildMixin('tab')],
  props: {
    disabled: Boolean
  },
  data: function data() {
    return {
      elementClass: 'tab-item'
    };
  }
};
/* script */

var __vue_script__$1 = script$1;
/* template */

/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = undefined;
/* style inject */

/* style inject SSR */

var TabItem = __vue_normalize__({}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Tabs);
    registerComponent(Vue, TabItem);
  }
};
use(Plugin);
export default Plugin;
export { TabItem as BTabItem, Tabs as BTabs };